import { render, staticRenderFns } from "./Fuw.vue?vue&type=template&id=48dd3e19&"
import script from "./Fuw.vue?vue&type=script&lang=js&"
export * from "./Fuw.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports